import { Box, TextField, InputAdornment, FormControl } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DatePreview = ({ question }) => {
  const { config } = question;

  return (
    <>
      <Box sx={{ minWidth: '150px' }}>
        <FormControl style={{ width: '150px' }}>
          <TextField
            label='Date'
            name='value'
            value={config?.placeholder || 'DD/MMM/YYYY'}
            className='custom-text-field'
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <FontAwesomeIcon
                    icon={['far', 'calendar']}
                    style={{
                      with: '18px',
                      height: '18px',
                      color: '#0000008F'
                    }}
                  />
                </InputAdornment>
              )
            }}
            variant='standard'
          />
        </FormControl>
      </Box>
    </>
  );
};

export default DatePreview;
